import {InteractionRequiredAuthError, PublicClientApplication} from "@azure/msal-browser";
import { msalConfig, tokenRequest, loginRequest } from "@/auth/authConfig";

class AuthService {
  private msal: PublicClientApplication;

  constructor() {
    this.msal = new PublicClientApplication(msalConfig);
  }

  public signIn() {
    return this.msal.loginRedirect({
      scopes: loginRequest.scopes
    });
  }

  public async handleSignInRedirect() {
    const response = await this.msal.handleRedirectPromise();

    if (response !== null) {
      this.msal.setActiveAccount(response.account);
    }
  }

  public async getToken() {
    try {
      const result = await this.msal.acquireTokenSilent({
        scopes: tokenRequest.scopes
      });

      return result.idToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await this.msal.acquireTokenRedirect({
          scopes: tokenRequest.scopes
        });
      }

      return null;
    }
  }

  public async signOut() {
    return this.msal.logoutRedirect({
      account: this.msal.getActiveAccount()
    });
  }
}

export default new AuthService();
